/**
 * API Configuration
 * Centralizes API endpoint URLs and configuration
 */

// Base API URL based on environment
const API_BASE_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : '';

// API Endpoints
export const API_ENDPOINTS = {
  galleryImages: `${API_BASE_URL}/api/gallery-images`,
  sendEnquiry: `${API_BASE_URL}/api/send-enquiry`,
};

/**
 * Helper function to get full API URL
 * @param {string} endpoint - The endpoint key from API_ENDPOINTS
 * @returns {string} - The full API URL
 */
export const getApiUrl = (endpoint) => {
  return API_ENDPOINTS[endpoint] || endpoint;
};
